module.exports = Object.freeze({
  OPEN: 'Open',
  CLOSED: 'Closed',
  ARCHIVED: 'Archived'
});